import maps from "@/assets/images/maps.png";
import { Terminal } from '@/models/terminal';
import { Card, Col, Descriptions, Empty, Image, Progress, Row, Statistic, Tabs, TabsProps } from 'antd';
import { useTranslation } from 'react-i18next';
import TransactionLog from '../../audit-logs/components/transaction-log/transaction-log';
import RoundNumber from './display';
import './index.scss';
import { TerminalType } from "@/constants/app.enums";
import { BlockOutlined, BoxPlotOutlined, CheckCircleOutlined, DatabaseOutlined, DesktopOutlined, InboxOutlined, LikeOutlined, MoreOutlined, SyncOutlined, WifiOutlined } from '@ant-design/icons';


interface TerminalDetailProps {
  terminal?: Terminal;
}

function BasicInformation(props: TerminalDetailProps) {
  const { t } = useTranslation();
  return (
    <Row gutter={16}>
      <Col span={16}>
        <Card
          style={{ marginTop: 16 }}
          title="Dashboard"
          className='dashboard'
        >
          <Row>
            <Col span={12}>
              <Card>
                <Statistic title="RAM" value="21.17%" prefix={<BoxPlotOutlined />} />

              </Card>
            </Col>
            <Col span={12}>
              <Card>
                <Statistic title="CPU" value="23.00%" precision={2} prefix={<BlockOutlined />} />
              </Card>

            </Col>
            <Col span={12}>
              <Card>
                <Statistic title="Battery" value="66%" prefix={<DatabaseOutlined />} />
              </Card>
            </Col>
            <Col span={12}>
              <Card>
                <Statistic title="Storage" value="1.69GB Used" prefix={<InboxOutlined />} />
              </Card>
            </Col>
            <Col span={12}>
              <Card>
                <Statistic title="Wifi" value="66%" prefix={<WifiOutlined />} />
              </Card>
            </Col>
            <Col span={12}>
              <Card>
                <Statistic title="Cloud" value="1.8GB Used" prefix={<InboxOutlined />} />
              </Card>
            </Col>
          </Row>
          {/* <Row>
            <Col span={24}>
              <div className='location-map'>
                <Image
                  src={maps}
                />
              </div>
            </Col>
          </Row> */}


        </Card>
      </Col>

      <Col span={8}>
        <Card
          style={{ marginTop: 16 }}
          title="Device Detail"
        >
          <Row>
            <Col span={24}>
              <Descriptions size="small" column={1}>
                <Descriptions.Item label="Terminal Name">{props.terminal?.lszTerminalName ?? "-"}</Descriptions.Item>
                <Descriptions.Item label="SN">{props.terminal?.terminalSerialNumber ?? "-"}</Descriptions.Item>
                <Descriptions.Item label="Location">{props.terminal?.terminalLocation ?? "-"}</Descriptions.Item>
                <Descriptions.Item label="Merchant">{props.terminal?.merchantName ?? "-"}</Descriptions.Item>
                <Descriptions.Item label="Brand">{props.terminal?.brand ?? "-"}</Descriptions.Item>
                <Descriptions.Item label="Model">{props.terminal?.model ?? "-"}</Descriptions.Item>
                <Descriptions.Item label="Type">{props.terminal?.terminalType === TerminalType.Kiosk ? "Kiosk" : "Payment"}</Descriptions.Item>
                <Descriptions.Item label="Screen Resolution">{props.terminal?.screenRevolution ?? "-"}</Descriptions.Item>
              </Descriptions>
              <br />
              <Descriptions size="small" column={2}>
                <Descriptions.Item label="Android Version">{"-"}</Descriptions.Item>
                <Descriptions.Item label="IMEI">{"-"}</Descriptions.Item>
                <Descriptions.Item label="IP">{"-"}</Descriptions.Item>
                <Descriptions.Item label="Time Zone">{"-"}</Descriptions.Item>
                <Descriptions.Item label="MAC Address">{"-"}</Descriptions.Item>
                <Descriptions.Item label="Created Time">{"-"}</Descriptions.Item>
                <Descriptions.Item label="Activation Time">{"-"}</Descriptions.Item>
                <Descriptions.Item label="Last Access Time">{"-"}</Descriptions.Item>
                <Descriptions.Item label="Remark">{"-"}</Descriptions.Item>
              </Descriptions>
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
  );
}
export default BasicInformation;
